var r = Array.isArray;
export {
  r as i
};
